<template>
    <div :class="apptype == 'Roewe' ? 'rw_home' : 'mg_home'" :style="styleOverflew">
        <div class="kv">
            <div class="shipping-address" @click.stop="deliveryAddressFun(1)"></div>
            <div class="activity-rules" @click="activityRules"></div>
        </div>
        <div class="content">
            <div class="activity">
                <div class="next-btn" @click="activityOne"></div>
            </div>
            <div class="activity-one">
                <div class="header-title"></div>
                <swiper :apptype="apptype" :scource="scource"></swiper>
            </div>
        </div>
        <!-- 返回按钮 -->
        <div class="close_page" @click="closepage"></div>
        <!-- toast弹框 -->
        <div class="toast" v-if="toastPopup">{{toastContent}}</div>
        <!-- 弹框 -->
        <div class="mask" v-if="regulationPopup || doubleElevenCoinCertificate || loading">
            <div class="loading positionabsolute" v-if="loading">
                <div class="pswp__preloader__icn">
                    <div class="pswp__preloader__cut">
                      <div class="pswp__preloader__donut"></div>
                    </div>
                  </div>
                  <div class="title">
                      数据加载中
                  </div>
            </div>
            <!-- 双十一兑换券提醒 -->
            <div class="double-eleven-coin-certificate positionabsolute" v-if="doubleElevenCoinCertificate">
                <div class="close-acquisition" @click="closedoubleElevenCoinCertificate"></div>
            </div>
            <!-- 规则弹框 -->
            <div class="regulation-popup positionabsolute" v-if="regulationPopup">
                <div class="regulation-content">
                    <div class="rule-one"></div>
                    <p>2021年11月1日至2021年11月20日；</p>
                    <div class="rule-two"></div>
                    <p v-if="apptype=='Roewe'">1.用户在活动期间内需登录上汽荣威App参与活动；</p>
                    <p v-if="apptype=='MG'">1.用户在活动期间内需登录MG Live App参与活动；</p>
                    <p>2.所有用户均可参与本次车主狂欢节活动； </p>
                    <div class="rule-three"></div>
                    <p v-if="apptype=='Roewe'">欢迎来到荣威车主狂欢节！</p>
                    <p v-if="apptype=='MG'">欢迎来到MG车主狂欢节！</p>
                    <p>本次的活动形式是以掷骰子方式获得行动点来通过爱车之路，有机会获得大量好礼和积分。</p>
                    <p>狂欢节期间，用户可通过完成每日车主任务来获得行动点，完成一个任务即可获得一次行动点，一次行动点可掷一次骰子，以掷一次骰子的点数来获得一次随机行动步数，每日最多三次机会。</p>
                    <p>爱车之路中每个位置将随机出现不同内容，包含积分奖励、抽奖机会（奖品见下方权益列表）、活动福利信息。</p>
                    <table class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>每日车主任务</th><th>获得行动点</th></tr>
                        <tr><td>每日分享活动（微信朋友圈）</td><td>每日1次</td></tr>
                        <tr><td>每日论坛互动（话题讨论）</td><td>每日1次</td></tr>
                        <tr><td style="width:70%;">每日关注商品（优品商城）</td><td style="width:30%;">每日1次</td></tr>
                    </table>
                    <p>在爱车之路中可获取奖品列表如下：</p>
                    <table v-if="apptype=='Roewe'" class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>权益名称</th><th>数量</th></tr>
                        <tr><td>50积分</td><td>40000</td></tr>
                        <tr><td>酷我音乐月卡</td><td>1000</td></tr>
                        <tr><td style="width:80%;">猫眼电影券</td><td style="width:20%;">800</td></tr>
                        <tr><td>大嘴猴 Paul Frank 保温杯 </td><td>500</td></tr>
                        <tr style="color: #ff6419;"><td>米家桌面暖风机</td><td>300</td></tr>
                        <tr style="color: #ff6419;"><td>卡西欧2021 BATTLE G-SHOCK 王一博同款</td><td>5</td></tr>
                        <tr style="color: #ff6419;"><td>Airpods pro</td><td>2</td></tr>
                    </table>
                    <table v-if="apptype=='MG'" class="mg" border="1" cellpadding="0" cellspacing="0" style="border-collapse: collapse" bordercolor="#ffffff" width="100%" id="AutoNumber1">
                        <tr><th>权益名称</th><th>数量</th></tr>
                        <tr><td>50积分</td><td>40000</td></tr>
                        <tr><td>酷我音乐月卡</td><td>1000</td></tr>
                        <tr><td style="width:80%;">猫眼电影券</td><td style="width:20%;">800</td></tr>
                        <tr><td>大嘴猴 Paul Frank 保温杯</td><td>500</td></tr>
                        <tr><td>车载吸尘器套装</td><td>200</td></tr>
                        <tr><td>卡西欧2021 BATTLE G-SHOCK 王一博同款</td><td>5</td></tr>
                        <tr><td>Airpods pro</td><td>2</td></tr>
                    </table>
                    <div class="rule-four"></div>
                    <p v-if="apptype=='MG'">1.同一个用户只能参加一次本活动。同一身份证，同一手机终端，同一手机号，符合以上任一条件，均视为同一用户。“认证车主”权益以当前登录app内信息为准：例如已认证的MG车主，若使用同一账号通过MG Live App登录活动页面，则会被视为未认证车主；</p>
                    <p v-if="apptype=='Roewe'">1.同一个用户只能参加一次本活动。同一身份证，同一手机终端，同一手机号，符合以上任一条件，均视为同一用户。“认证车主”权益以当前登录app内信息为准：例如已认证的荣威车主，若使用同一账号通过上汽荣威App登录活动页面，则会被视为未认证车主；</p>
                    <p>2.参与活动获得的领奖权益不可转赠他人，所有奖品不可折现、不可退换；</p>
                    <p>3.用户应充分了解本活动所设的活动规则并遵照执行。如经核实用户有违规、作弊等情况，除按照相关协议及规则处理外，所获活动权益也可能被取消；</p>
                    <p>4.奖品于活动结束后的20个工作日内发放。如出现不可抗力或情势变更的情况（例如物流政策变更导致奖品无法按计划发放），用户需理解活动主办方可依相关法律规定主张免责；</p>
                    <p>5.本次活动涉及的奖品以实物为准。</p>
                    <p>6.活动规则可能根据本活动实际情况进行调整，调整后的规则将公布在活动页面上，并于公布时即时生效。</p>
                </div>
                <div class="regulation-btn" @click="closeRegulationPopup"></div>
            </div>
        </div>
  </div>
</template>

<script>
    import swiper from '../components/swiper'
export default {
  name: 'Home',
  data() {
        return {
            loading:false,
            doubleElevenCoinCertificate:false,  //双十一兑换券提示框
            styleOverflew:'overflow-y: scroll;',
            apptype: "Roewe",  //roewe为名荣威  mg为名爵
            // userToken: "215d5d3290ac47ae9d76b63636c62126-prod_SAIC", // 用户token
            userToken: "8af9002e717348a88d21a208abf7a9be-prod_SAIC", // 用户token
            toastPopup:false,  //toast提示弹框
            toastContent:'',  //toast提示内容
            address:{},   //地址信息
            nextreturn:true,  //防止二次点击
            userinfo:{},  //用户信息
            scource:'',
            regulationPopup:false,  //规则弹框
            tenPrizeInfo:[],  //双十一兑换券
            acquirePrizes:[]
        };
    },
    components:{swiper},
    mounted() {
        if (this.apptype == "Roewe") {
            require("../../public/css/home-rw.less");
        } else {
            require("../../public/css/home-mg.less");
        }
    },
    created() {
        this.loadFun()
        if(window.location.href.indexOf('?')==-1){
            this.scource = 'index'
        }else{
            this.scource = this.getSearchString('scource',window.location.href)
        }
        if(this.scource.indexOf('#')==-1){
            this.scource = this.scource
        }else{
            this.scource = this.scource.split('#')[0]
        }
        window.localStorage.setItem('scource',this.scource)
        this.apptype = 'MG'
        this.getUserToken();
        // this.getlist()
        // this.gettenprizeinfo()
    },
    methods: {
        // 关闭双十一兑换券提示框
        closedoubleElevenCoinCertificate(){
            this.doubleElevenCoinCertificate = false
            this.styleOverflew='overflow-y: scroll;'
            window.localStorage.setItem('rmcoincertificate','rmcoincertificate')
        },
        activityOne(){
            this.$router.push('/grame')
        },
        // 关闭规则弹框
        closeRegulationPopup(){
            this.regulationPopup = false
            this.styleOverflew='overflow-y: scroll;'
        },
        // 查找字符串中是否有英文字符
        hasLetter(str) {
            for (var i in str) {
                var asc = str.charCodeAt(i);
                if ((asc >= 65 && asc <= 90 || asc >= 97 && asc <= 122)) {
                    return true;
                }
            }
            return false;
        },
       
        // 随机数
        random(a,b){
            return Math.round(Math.random()*(a-b)+b);
        },
        
        // 规则弹框
        activityRules(){
            this.regulationPopup = true
            this.styleOverflew='overflow-y: hidden;'
        },
        getSearchString(key, Url) {  //key为要获取的字段，url为获取字段的链接
            var str = Url;
            str = str.split('?')[1]
            // str = str.substring(1, str.length); // 获取URL中?之后的字符（去掉第一位的问号）
            // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
            var arr = str.split("&");
            var obj = new Object();
            // 将每一个数组元素以=分隔并赋给obj对象
            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        },
        // 阿里埋点代码
        track(action, name,source,text,url,userid, uesrtype ) {
            // if(name=='name'){
            //     var params = { userId: userid, userType: uesrtype,source:source,url:url}
            // }else{
            //     var params = { userId: userid, userType: uesrtype,source:source,url:url,name:name}
            // }
            var params = { name:name,source:source,text:text,url:url,userId: userid, userType: uesrtype}
            var _baq = window._baq || []
            //_trackEvent页面交互事件
            _baq.push(['_trackEvent', action, params])
        },
        closepage(){
            const closeWin = (closeNowWin) => {
                if (closeNowWin) {
                    //关闭当前页面回到上级
                    window.closeWebView()
                } else {
                    //回到首页
                    window.closeWebView('root')
                }
            }
            closeWin()
        },
        // 去填写收货地址
        deliveryAddressFun(data){
            if(data && data!=1){
                this.acquirePrizes.push(data)
            }
            if (this.apptype == "Roewe") {
                this.$router.push({path:'/rwAddress'})
            } else {
                this.$router.push({path:'/mgAddress'})
            }
        },
        // 未登陆时调用去登录页面
        backToApp() {
            window.serviceError("14101", (res) => {
                console.log(res);
            });
        },
        // 获取用户token
        getUserToken() {
            window.getToken(this.callback);
        },
        // getToken回调
        callback(res) {
            if (res.token) {
                // setInterval(() => {
                //     console.log("token，", res.token);
                // }, 5000);
                window.localStorage.setItem('zebra-token',res.token)
                this.userToken = res.token;
                if(!window.localStorage.getItem('rmcoincertificate')){
                    this.gettenprizeinfo()
                }
                // this.getlist();
            } else {
                // console.log("token为空");
                this.backToApp();
            }
        },
        // 活动一的信息
        getlist() {
            this.loading = true
            this.acquirePrizes = []
            let that = this;
            that.$http.post("/getInfo", {
              brandCode: "2", // 1:荣威，2:名爵
                token: that.userToken,
            }).then((res) => {
                console.log(res)
                if(res.data.code==0){
                    window.localStorage.setItem('Authorization',res.data.data.H5Token)
                    res.data.data.prizeInfo.map((v)=>{
                        this.acquirePrizes.push(v.prize_name)
                    })
                    // res.data.data.tenPrizeInfo.map((v)=>{
                    //     this.tenPrizeInfo.push(v.prize_name)
                    // })
                    // if(this.tenPrizeInfo.length>0){
                    //     if(!window.localStorage.getItem('rmcoincertificate')){
                    //         this.doubleElevenCoinCertificate = true
                    //         this.styleOverflew='overflow-y: hidden;'
                    //     }
                    // }
                    this.address = res.data.data.info.address || {}
                   this.loading = false
                    // if(JSON.stringify(this.userinfo)=='{}'){
                    //     if(res.data.data.info.is_owner==1){
                    //         this.track('moonFestival_pageView','',this.scource,'','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html', res.data.data.info.user_id, 'bindUser')
                    //     }else{
                    //         this.track('moonFestival_pageView','',this.scource, '','https://h5case4.xiaoxxx.cn/202109/roewe/dist/index.html',res.data.data.info.user_id, 'unbindUser')
                    //     }
                    // }              
                    // this.userinfo = res.data.data
                    //1是车主2不是车主
                }
            });
        },
        gettenprizeinfo(){
            this.$http.post("/getCouponsPrizeInfo", {
              brandCode: "2", // 1:荣威，2:名爵
                // token: this.userToken,
            }).then((res) => {
                if(res.data.code==0){
                    res.data.data.tenPrizeInfo.map((v)=>{
                        this.tenPrizeInfo.push(v.prize_name)
                    })
                    window.localStorage.setItem('tenPrizeInfo',JSON.stringify(this.tenPrizeInfo))
                    if(this.tenPrizeInfo.length>0){
                        if(!window.localStorage.getItem('rmcoincertificate')){
                            this.doubleElevenCoinCertificate = true
                            this.styleOverflew='overflow-y: hidden;'
                        }
                    }
                }
            })
        },
        // 加载
        loadFun(){
            let that = this
            let imgarr_rw = [
                "https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211101f530989a77f8cf88454405.jpg",
            ];
            let imgarr_mg = [
                "https://res.xiaoxxx.com/test/m.xiaoxxx.com/202111011c62431cffe6ec68700606.jpg",
            ];
            var iii = 0;
            var iiiarr = 23;
            var imgarr = that.apptype == "Roewe" ? imgarr_rw : imgarr_mg;
            for (var i = 0; i < imgarr.length; i++) {
                var img = new Image();
                // console.log("第" + iii + "个img开始")
                img.onload = function () {
                    iii = iii + 1;
                    // console.log("第" + iii + "个img加载完成")
                    that.loading_num = Math.floor(
                        ((iiiarr - (iiiarr - iii)) / iiiarr) * 100
                    );
                    if (iiiarr === iii) {
                        // console.log("第一批图片加载完成")
                        setTimeout(() => {
                            that.isloading = false
                            
                        }, 1500);
                    }
                };
                img.onerror = function () {
                // console.log("第" + iii + "个img加载error")
                };
                img.src = imgarr[i];
            }
        }
    },
}
</script>
